const BANNED_USER_CHANNEL = 'banned-user-channel'
export const BANNED_USER_EVENT = 'user-banned'

let broadcastChannel: BroadcastChannel | null = null

export const initializeBannedUserChannel = (onBanned: () => void) => {
  if (typeof BroadcastChannel === 'undefined' || broadcastChannel) {
    return
  }

  broadcastChannel = new BroadcastChannel(BANNED_USER_CHANNEL)

  broadcastChannel.onmessage = (event) => {
    if (event.data === BANNED_USER_EVENT) {
      onBanned()
    }
  }
}

export const notifyUserBanned = () => {
  window.location.href = '/no-access?reason=banned'
  if (broadcastChannel) {
    broadcastChannel.postMessage(BANNED_USER_EVENT)
  }
}
